import { useMemo } from 'react';

import { LoadingLayout } from 'components';
import { ErrorFallback } from 'modules/App/ErrorFallback';
import { filterVisibleOnboardingStatuses } from 'modules/client/common/helpers/filterVisibleOnboardingStatuses';

import { useLegalClientVersion } from '../hooks/useLegalClientVersion';
import { LegalClientVersionView } from '../views/LegalClientVersionView';

export const LegalClientVersionContainer = () => {
  const {
    initialValues,
    loading,
    error,
    versions,
    breadcrumbsTitles,
    fullName,
    snapshot,
    snapshotLoading,
    versionId,
    legalClient,
    onClickRepresentative,
    onChangeVersion,
    onCloseVersionHistory,
    onClickBeneficiary,
    onClickHead,
    onClickLegalHead,
    onClickBranch,
  } = useLegalClientVersion();

  const visibleOnboardingStatuses = useMemo(
    () => filterVisibleOnboardingStatuses(snapshot?.value.onboarding?.statuses),
    [snapshot?.value.onboarding?.statuses]
  );

  if (error) {
    return <ErrorFallback />;
  }

  if (loading) {
    return <LoadingLayout />;
  }

  return (
    <LegalClientVersionView
      hideActivitySection
      beneficiaries={snapshot?.value.beneficiaries ?? []}
      bodies={snapshot?.value.bodies ?? []}
      branches={snapshot?.value.branches ?? []}
      breadcrumbsTitles={breadcrumbsTitles}
      countries={[]}
      currentAccountStatus={snapshot?.value.accountStatus}
      currentOnboardingStatus={snapshot?.value.onboardingStatus}
      fullName={fullName}
      heads={snapshot?.value.heads ?? []}
      initialValues={initialValues}
      legalHeads={snapshot?.value.legalHeads ?? []}
      managers={[]}
      representativeInfo={
        snapshot?.value.representative ?? legalClient?.representative
      }
      snapshotLoading={snapshotLoading}
      unidentifiableBeneficiaryLetterFiles={
        snapshot?.value.unidentifiableBeneficiaryLetterFiles
      }
      versionId={versionId}
      versions={versions ?? []}
      visibleOnboardingStatuses={visibleOnboardingStatuses}
      onChangeVersion={onChangeVersion}
      onClickBeneficiary={onClickBeneficiary}
      onClickBranch={onClickBranch}
      onClickHead={onClickHead}
      onClickLegalHead={onClickLegalHead}
      onClickRepresentative={onClickRepresentative}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  );
};
